module.exports = __webpack_public_path__ + "static/hvik_pabbi_2-ce19096c022a15418f23c4d5fd5b924c.jpg";